import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: '[restrictInput]'
})

export class RestrictInput implements OnInit {

    @Input("restrict") public set restrict(value) {
        this._restrict = value;
    }

    public get restrict(): any {
        return this._restrict;
    }

    private _restrict: any = /[,|*^&=]/gim;

    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        if (this.restrict != null) {
            this.validateFields(event);
        }
    }

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        if (this.restrict != null) {
            this.validateFields(event);
        }
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        if (this.restrict != null)
            this.validateFields(event);
    }
    
    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        if (this.restrict != null)
            this.validateFields(event);
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        if (this.restrict != null)
            this.validateFields(event);
    }

    validateFields(event?) {
        setTimeout(() => {
            this.el.nativeElement.value = this.el.nativeElement.value.replace(this.restrict, '');

            if (this.model != null) {
                this.model.viewToModelUpdate(this.el.nativeElement.value);
            }

            if (event)
                event.preventDefault();
        });
    }

    constructor(private el: ElementRef, private model: NgModel) {}

    ngOnInit(): void {
        if (this.restrict != null)
            this.validateFields();
    }
}